import { getCsrfToken } from './get_csrf_token';

const jsonHeaders = () => ({
  'Content-Type': 'application/json',
  Accept: 'application/json',
  'X-CSRF-Token': getCsrfToken(),
});

export async function bootstrapVpeSession({ versionId, threadId }) {
  const body = { version_id: versionId };
  if (threadId) body.thread_id = threadId;

  const response = await fetch('/ai_assistant/vpe_sessions', {
    method: 'POST',
    headers: jsonHeaders(),
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    const errorBody = await response.json().catch(() => ({}));
    throw new Error(errorBody.error || `Session bootstrap failed (${response.status})`);
  }

  return response.json();
}

export async function appendVtvMessages({ threadId, messages }) {
  const response = await fetch(`/ai_assistant/threads/${threadId}/append_messages`, {
    method: 'POST',
    headers: jsonHeaders(),
    body: JSON.stringify({ messages }),
  });

  if (!response.ok) {
    const errorBody = await response.json().catch(() => ({}));
    throw new Error(errorBody.error || `Append messages failed (${response.status})`);
  }

  return response.json();
}

export async function fetchVpeChatThreadMount(threadId) {
  const response = await fetch(
    `/ai_assistant/messages/vpe_chat_thread_mount?thread_id=${encodeURIComponent(threadId)}`,
    { headers: { Accept: 'text/html', 'X-CSRF-Token': getCsrfToken() } },
  );

  if (!response.ok) {
    throw new Error(`Thread mount failed (${response.status})`);
  }

  return response.text();
}
